import React, { useEffect, useState } from 'react';
import { AdaptiveModal } from '../Common/AdaptiveModal';
import { suggestedCopyName } from '../../api/frameworks';

export default function NameCopyDialog({
  isOpen,
  originalName,
  title = 'Name this copy',
  confirmLabel = 'Create copy',
  onCancel,
  onConfirm,
}) {
  const [name, setName] = useState(suggestedCopyName(originalName));

  useEffect(() => {
    if (isOpen) {
      setName(suggestedCopyName(originalName));
    }
  }, [isOpen, originalName]);

  if (!isOpen) return null;

  return (
    <AdaptiveModal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      footer={(
        <div className="fw-dialog-actions">
          <button type="button" className="fw-btn fw-btn--ghost" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="fw-btn fw-btn--primary"
            onClick={() => onConfirm(name.trim())}
            disabled={!name.trim()}
          >
            {confirmLabel}
          </button>
        </div>
      )}
    >
      <label className="fw-field">
        <span className="fw-field__label">Framework name</span>
        <input
          className="fw-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          maxLength={100}
        />
      </label>
    </AdaptiveModal>
  );
}
